<div class="pbiLoaderWrapper">
    <table id="wrapper" class="pbiLoaderImagewrapper">
        <tr>
            <td>
                <img [src]="logoUrl" class="pbiLoaderImage" />
            </td>
        </tr>
      </table>
    <svg class="pl" viewBox="0 0 160 160" width="160px" height="160px" xmlns="http://www.w3.org/2000/svg" >
        <defs>
            <linearGradient id="grad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stop-color="#000" />
                <stop offset="100%" stop-color="#fff" />
            </linearGradient>
            <mask id="mask1">
                <rect x="0" y="0" width="160" height="160" fill="url(#grad)" />
            </mask>
            <mask id="mask2">
                <rect x="20" y="20" width="120" height="120" fill="url(#grad)" />
            </mask>
        </defs>
        <g>
            <g class="pl__ring-rotate">
                <circle class="pl__ring-stroke" cx="80" cy="80" r="72" fill="none" stroke="hsl(223,30%,40%)" stroke-width="8" stroke-dasharray="452.39 452.39" stroke-dashoffset="452" stroke-linecap="round" transform="rotate(-45,80,80)" />
            </g>
        </g>
        <g mask="url(#mask1)">
            <g class="pl__ring-rotate">
                <circle class="pl__ring-stroke" cx="80" cy="80" r="72" fill="none" stroke="hsl(193,30%,40%)" stroke-width="8" stroke-dasharray="452.39 452.39" stroke-dashoffset="452" stroke-linecap="round" transform="rotate(-45,80,80)" />
            </g>
        </g>
    </svg>
</div>
